import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Store } from '@ngxs/store';
import { TokenExpired } from '../actions/auth-actions';
import { NavigateToLogin } from 'src/app/states/navigations.actions';
import { GoogleAnalyticsService } from 'src/modules/analytics/services/google-analytics.service';
import { AnalyticsEventName } from 'src/modules/analytics/models/analytics-event-name.enum';

export const authGuard = (): boolean => {
  const authService: AuthService = inject(AuthService);
  const store: Store = inject(Store);
  const analyticsService: GoogleAnalyticsService = inject(GoogleAnalyticsService);
  const canActivate = authService.isAuthenticated();

  if (!canActivate) {
    const isExpired = authService.isExpired();

    if (isExpired) {
      analyticsService.trackEvent(AnalyticsEventName.SessionAutoLogout);
      store.dispatch(new TokenExpired());
    } else {
      store.dispatch(new NavigateToLogin());
    }
  }

  return canActivate;
};
